import React from 'react';
import Table from './Table'
import {Requestdynamic} from '../../Network/Fetch';
import PopUp from './PopUp'
import PopUpDelete from './PopUpDelete'
import Loading from './Loading'
import Cookies from 'universal-cookie'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

class AllAdmin extends React.Component {
  constructor(props){
      super(props);
      this.state = {
        admin: [],
        loadingAdmin: true,
        openModal: false,
        title: null,
        message: null,
        searchResult: null,
        openModalDelete: false,
        deleting: null,
        AdminDelete: null,
        NotAcces: null
      }
    }

    _getAllAdmin = async () => {
      this.setState({loadingAdmin: true}, async() => {
        await this.sleep(150)
        var cookies = new Cookies();
        var Jwt = cookies.get('acces');

        var Params = {
            Jwt: Jwt,
        }
        var promise = await Requestdynamic('_getAllAdmin', Params)
        if(promise.error === false && promise.data.error === false)
        {
          this.setState({loadingAdmin: false, admin: promise.data.data})
        }
        else {
          if (promise.error === true){
            this.setState({loadingAdmin: false, title: 'Error', openModal: true, message: "Un problème est survenue veuillez réesayer plus tard"})
            return ;
          }
          else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true){
            cookies = new Cookies();
            cookies.remove('acces', { path: '/' })
            cookies.remove('infoAdmin', { path: '/' })
            await this.sleep(900)
            var url = '/login'
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            return ;
          }
        else {
          this.setState({loadingAdmin: false, title: 'Error', openModal: true, message: "Un problème est survenue veuillez réesayer plus tard"})
        }
        }
      })

    }

    componentDidMount(){
     this._getAllAdmin()
    }

     sleep = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    _deleteAdmin = () => {
      this.setState({deleting: "Waiting", NotAcces: null}, async () => {
        var cookies = new Cookies();
        var Jwt = cookies.get('acces');

        var Params = {
            Jwt: Jwt,
            IdAdmin: this.state.AdminDelete.Id,
        }
        await this.sleep(2000)
        var promise = await Requestdynamic('_deleteAdmin', Params)
        if(promise.error === false && promise.data.error === false)
        {
          this.setState({deleting: 'Success'}, async () => {
            await this.sleep(1500)
            var Copy = [...this.state.admin];
            var index = Copy.findIndex(res => res.Id === this.state.AdminDelete.Id)
            if (index === -1){
              this.setState({deleting: null, AdminDelete: null, openModalDelete: null})
              return ;
            }
            Copy.splice(index, 1)
            this.setState({admin: Copy})
            await this.sleep(650)
            this.setState({deleting: null, AdminDelete: null, openModalDelete: null})
          })
        }
        else {
          if (promise.error === true)
           this.setState({deleting: "Error"})
         else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true){
           cookies.remove('acces', { path: '/' })
           cookies.remove('infoAdmin', { path: '/' })
           await this.sleep(900)
           var url = '/login'
           const link = document.createElement('a');
           link.href = url;
           document.body.appendChild(link);
           link.click();
           link.parentNode.removeChild(link);
           return ;
         }
         else{
           this.setState({deleting: "Error", NotAcces: promise.data.NotAccess ? true : null})
         }
        }
      })

    }


 render() {

   return (
     <div style={{marginLeft: 10, overflowY: "auto"}} onScroll={this.handleScroll}>
     <PopUp openModal={this.state.openModal} message={this.state.message} title={this.state.title} refParent={this}/>
     <PopUpDelete NotAcces={this.state.NotAcces} AdminDelete={this.state.AdminDelete} deleting={this.state.deleting} openModalDelete={this.state.openModalDelete} refParent={this}/>
     <Container fluid>
       <Row>
         <Col sm={12} xl={12} md={12} lg={12} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
           <h2 style={{textAlign: 'left', marginBottom: 25}}>Administrateurs</h2>
         </Col>
       </Row>
     </Container>
     <Table refParent={this} deleting={this.state.deleting} admin={this.state.admin} loadingAdmin={this.state.loadingAdmin} intl={this.props.intl}/>
     <Loading loadingMore={this.state.loadingAdmin}/>

    </div>
   )
 }
}


export default AllAdmin;
